<div class="layout-main">
  <a href="#campaign-form" class="skip-to-content">{{ 'supervisor.campaignView.skipToContent' | translate }}</a>
  <!-- Main campaign card container -->
  <div class="card-container" [ngClass]="{'loading-state': isLoading}">
    <!-- isLoading aplica una vaina rara en dorado -->

    <!-- Card header with status announcement -->
    <span class="header">
      <i class="pi pi-megaphone" aria-hidden="true"></i>
      <span>{{ (campaignId ? (isEditing ? 'supervisor.campaignView.header.edit' : 'supervisor.campaignView.header.view') : 'supervisor.campaignView.header.create') | translate }} {{ 'supervisor.campaignView.header.campaign' | translate }}</span>
      <span *ngIf="campaignId" class="campaign-id">{{ 'supervisor.campaignView.header.id' | translate }}: {{ campaignId }}</span>
    </span>


    <!-- Campaign Form -->
    <form id="campaign-form" [formGroup]="campaignForm" class="campaign-form" aria-describedby="form-status"
          [attr.aria-disabled]="isLoading || (!isEditing && campaignId)">

      <!-- Screen reader only status announcements -->
      <div id="form-status" aria-live="polite" class="sr-only">
        <span *ngIf="isLoading">{{ 'supervisor.campaignView.status.loading' | translate }}</span>
        <span *ngIf="!isEditing && campaignId">{{ 'supervisor.campaignView.status.readonly' | translate }}</span>
        <span *ngIf="isEditing">{{ 'supervisor.campaignView.status.editing' | translate }}</span>
        <span *ngIf="campaignForm.dirty">{{ 'supervisor.campaignView.status.unsavedChanges' | translate }}</span>
      </div>

      <!-- Basic Information Section -->
      <div class="form-section">
        <span class="section-title">{{ 'supervisor.campaignView.sections.basicInfo' | translate }}</span>

        <!-- Nombre -->
        <div class="field required span-6" [class.field-changed]="isFieldDirty('name')"
             [class.field-invalid]="isFieldInvalid('name')">
          <label for="name" id="name-label">{{ 'supervisor.campaignView.fields.name' | translate }}</label>
          <input id="name"
                 pInputText
                 formControlName="name"
                 aria-labelledby="name-label"
                 [attr.aria-invalid]="isFieldInvalid('name')"
                 [attr.aria-describedby]="isFieldInvalid('name') ? 'name-error' : null"
                 autocomplete="off"/>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('name')"
                 id="name-error"
                 role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.nameRequired' | translate }}
          </small>
        </div>

        <!-- Nombre Campaña -->
        <div class="field required span-6"
             [class.field-changed]="isFieldDirty('campaign_name')"
             [class.field-invalid]="isFieldInvalid('campaign_name')">
          <label for="campaign_name" id="campaign-name-label">{{ 'supervisor.campaignView.fields.campaignName' | translate }}</label>
          <input id="campaign_name"
                 pInputText
                 formControlName="campaign_name"
                 aria-labelledby="campaign-name-label"
                 [attr.aria-invalid]="isFieldInvalid('campaign_name')"
                 [attr.aria-describedby]="isFieldInvalid('campaign_name') ? 'campaign-name-error' : null"
                 autocomplete="off"/>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('campaign_name')"
                 id="campaign-name-error"
                 role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.campaignNameRequired' | translate }}
          </small>
        </div>

        <!-- Tipo -->
        <div class="field required span-3" [class.field-changed]="isFieldDirty('type')"
             [class.field-invalid]="isFieldInvalid('type')">
          <label for="type" id="type-label">{{ 'supervisor.campaignView.fields.type' | translate }}</label>
          <p-dropdown id="type"
                      [options]="typeOptions"
                      formControlName="type"
                      [placeholder]="'supervisor.campaignView.placeholders.selectType' | translate"
                      aria-labelledby="type-label"
                      [attr.aria-invalid]="isFieldInvalid('type')"
                      [attr.aria-describedby]="isFieldInvalid('type') ? 'type-error' : null"
                      [autoDisplayFirst]="false">
          </p-dropdown>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('type')"
                 id="type-error"
                 role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.typeRequired' | translate }}
          </small>
        </div>

        <!-- Estado -->
        <div class="field required span-3"
             [class.field-changed]="isFieldDirty('state')"
             [class.field-invalid]="isFieldInvalid('state')">
          <label for="state" id="state-label">{{ 'supervisor.campaignView.fields.state' | translate }}</label>
          <p-dropdown id="state"
                      [options]="stateOptions"
                      formControlName="state"
                      [placeholder]="'supervisor.campaignView.placeholders.selectState' | translate"
                      aria-labelledby="state-label"
                      [attr.aria-invalid]="isFieldInvalid('state')"
                      [attr.aria-describedby]="isFieldInvalid('state') ? 'state-error' : null"
                      [autoDisplayFirst]="false">
          </p-dropdown>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('state')"
                 id="state-error"
                 role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.stateRequired' | translate }}
          </small>
        </div>

        <!-- Prioridad -->
        <div class="field required span-3"
             [class.field-changed]="isFieldDirty('priority')"
             [class.field-invalid]="isFieldInvalid('priority')">
          <label for="priority" id="priority-label">{{ 'supervisor.campaignView.fields.priority' | translate }}</label>
          <p-inputNumber id="priority"
                         formControlName="priority"
                         [min]="1"
                         [max]="100"
                         [showButtons]="true"
                         buttonLayout="horizontal"
                         spinnerMode="horizontal"
                         decrementButtonClass="p-button-secondary"
                         incrementButtonClass="p-button-secondary"
                         incrementButtonIcon="pi pi-plus"
                         decrementButtonIcon="pi pi-minus"
                         aria-labelledby="priority-label"
                         [attr.aria-invalid]="isFieldInvalid('priority')"
                         [attr.aria-describedby]="isFieldInvalid('priority') ? 'priority-error' : null">
          </p-inputNumber>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('priority')"
                 id="priority-error"
                 role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.priorityRange' | translate }}
          </small>
        </div>

        <!-- Estado Desde -->
        <div class="field required span-3"
             [class.field-changed]="isFieldDirty('state_since')"
             [class.field-invalid]="isFieldInvalid('state_since')">
          <label for="state_since" id="state-since-label">{{ 'supervisor.campaignView.fields.stateSince' | translate }}</label>
          <p-calendar id="state_since"
                      formControlName="state_since"
                      [showTime]="true"
                      [showIcon]="true"
                      [showButtonBar]="true"
                      dateFormat="dd/mm/yy"
                      [firstDayOfWeek]="1"
                      aria-labelledby="state-since-label"
                      [attr.aria-invalid]="isFieldInvalid('state_since')"
                      [attr.aria-describedby]="isFieldInvalid('state_since') ? 'state-since-error' : null">
          </p-calendar>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('state_since')"
                 id="state-since-error"
                 role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.dateRequired' | translate }}
          </small>
        </div>
      </div>

      <!-- Additional Configuration Section -->
      <div class="form-section">
        <span class="section-title">{{ 'supervisor.campaignView.sections.additionalConfig' | translate }}</span>

        <!-- Ratio -->
        <div class="field required span-6"
             [class.field-changed]="isFieldDirty('ratio')"
             [class.field-invalid]="isFieldInvalid('ratio')">
          <label for="ratio" id="ratio-label">{{ 'supervisor.campaignView.fields.ratio' | translate }}</label>
          <input id="ratio"
                 pInputText
                 formControlName="ratio"
                 [placeholder]="'supervisor.campaignView.placeholders.ratioExample' | translate"
                 aria-labelledby="ratio-label"
                 [attr.aria-invalid]="isFieldInvalid('ratio')"
                 [attr.aria-describedby]="isFieldInvalid('ratio') ? 'ratio-error' : 'ratio-help'"
                 autocomplete="off"/>
          <small id="ratio-help" class="text-muted" *ngIf="!isFieldInvalid('ratio')">
            {{ 'supervisor.campaignView.help.ratioFormat' | translate }}
          </small>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('ratio')"
                 id="ratio-error"
                 role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.ratioFormat' | translate }}
          </small>
        </div>

        <!-- Acción Actual -->
        <div class="field required span-6"
             [class.field-changed]="isFieldDirty('current_action')"
             [class.field-invalid]="isFieldInvalid('current_action')">
          <label for="current_action" id="current-action-label">{{ 'supervisor.campaignView.fields.currentAction' | translate }}</label>
          <input id="current_action"
                 pInputText
                 formControlName="current_action"
                 aria-labelledby="current-action-label"
                 [attr.aria-invalid]="isFieldInvalid('current_action')"
                 [attr.aria-describedby]="isFieldInvalid('current_action') ? 'current-action-error' : null"
                 autocomplete="off"/>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('current_action')"
                 id="current-action-error"
                 role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.currentActionRequired' | translate }}
          </small>
        </div>

        <!-- Closing Reasons Column -->
        <div class="field span-12">
          <label for="new_reason" id="reason-label">{{ 'supervisor.campaignView.fields.closingReasons' | translate }}</label>
          <p-inputgroup>
            <input id="new_reason"
                   pInputText
                   [(ngModel)]="newReason"
                   [ngModelOptions]="{standalone: true}"
                   [placeholder]="'supervisor.campaignView.placeholders.enterReason' | translate"
                   aria-labelledby="reason-label"
                   (keyup.enter)="addReason()"
                   autocomplete="off"/>
            <button pButton
                    type="button"
                    icon="pi pi-plus"
                    (click)="addReason()"
                    [disabled]="!newReason.trim()"
                    [attr.aria-label]="'supervisor.campaignView.aria.addReason' | translate">
            </button>
          </p-inputgroup>

          <div class="reasons-list" role="list" [attr.aria-label]="'supervisor.campaignView.aria.closingReasonsList' | translate" [attr.aria-busy]="isLoading">
            @for (reason of campaignForm.get('closing_reason')?.value; track $index) {
              <div class="reason-item" role="listitem">
                <span>{{ reason }}</span>
                <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-sm"
                        (click)="removeReason(reason)" [attr.disabled]="(!isEditing && campaignId) ? true : null"
                        [attr.aria-label]="('supervisor.campaignView.aria.removeReason' | translate) + ' ' + reason"></button>
              </div>
            } @empty {
              <div class="text-center">
                <i class="pi pi-info-circle" aria-hidden="true"></i>
                {{ 'supervisor.campaignView.empty.noClosingReasons' | translate }}
              </div>
            }
          </div>
        </div>
      </div>

      <!-- General Configuration Section -->
      <div class="form-section" formGroupName="general_config">
        <span class="section-title">
          <i class="pi pi-cog title-icon" aria-hidden="true"></i>
          {{ 'supervisor.campaignView.sections.generalConfig' | translate }}
        </span>

        <div class="field span-6" role="group" aria-labelledby="general-config-title">
          <div class="config-group">
            <div class="config-group-title">
              <i class="pi pi-comments" aria-hidden="true"></i>
              <span>{{ 'supervisor.campaignView.generalConfig.conversationConfig' | translate }}</span>
            </div>

            <div class="toggle-field">
              <div class="p-field-checkbox">
                <p-inputSwitch formControlName="accept_conversation" [inputId]="'accept_conversation'"
                               [ngClass]="{'field-changed': isFieldDirty('general_config.accept_conversation')}"
                               aria-labelledby="accept-conversation-label" [disabled]="isReadonly">
                </p-inputSwitch>
                <label for="accept_conversation">{{ 'supervisor.campaignView.generalConfig.acceptConversations' | translate }}</label>
              </div>
              <span class="toggle-description">{{ 'supervisor.campaignView.generalConfig.acceptConversationsDesc' | translate }}</span>
            </div>
          </div>
        </div>

        <!-- Columna 2: Gestión de archivos -->
        <div class="field span-6" role="group" aria-labelledby="general-config-title">
          <div class="config-group">
            <div class="config-group-title">
              <i class="pi pi-file" aria-hidden="true"></i>
              <span>{{ 'supervisor.campaignView.generalConfig.fileManagement' | translate }}</span>
            </div>

            <div class="toggle-field">
              <div class="p-field-checkbox">
                <p-inputSwitch formControlName="enable_file_upload" [inputId]="'enable_file_upload'"
                               [ngClass]="{'field-changed': isFieldDirty('general_config.enable_file_upload')}"
                               aria-labelledby="file-upload-label" [disabled]="isReadonly">
                </p-inputSwitch>
                <label for="enable_file_upload">{{ 'supervisor.campaignView.generalConfig.allowFileUpload' | translate }}</label>
              </div>
              <span class="toggle-description">{{ 'supervisor.campaignView.generalConfig.allowFileUploadDesc' | translate }}</span>
            </div>

            <div class="toggle-field">
              <div class="p-field-checkbox">
                <p-inputSwitch formControlName="enable_file_download" [inputId]="'enable_file_download'"
                               [ngClass]="{'field-changed': isFieldDirty('general_config.enable_file_download')}"
                               aria-labelledby="file-download-label" [disabled]="isReadonly">
                </p-inputSwitch>
                <label for="enable_file_download">{{ 'supervisor.campaignView.generalConfig.allowFileDownload' | translate }}</label>
              </div>
              <span class="toggle-description">{{ 'supervisor.campaignView.generalConfig.allowFileDownloadDesc' | translate }}</span>
            </div>

            <!-- Nuevo: Habilitar campo Ticket -->
            <div class="toggle-field">
              <div class="p-field-checkbox">
                <p-inputSwitch formControlName="enable_ticket_field" [inputId]="'enable_ticket_field'"
                               [ngClass]="{'field-changed': isFieldDirty('general_config.enable_ticket_field')}"
                               aria-labelledby="ticket-field-label" [disabled]="isReadonly">
                </p-inputSwitch>
                <label for="enable_ticket_field">{{ 'supervisor.campaignView.generalConfig.enableTicketField' | translate }}</label>
              </div>
              <span class="toggle-description">{{ 'supervisor.campaignView.generalConfig.enableTicketFieldDesc' | translate }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Translation Configuration Section -->
      <div class="form-section" formGroupName="translation_config">
        <span class="section-title">
          <i class="pi pi-globe title-icon" aria-hidden="true"></i>
          {{ 'supervisor.campaignView.sections.translationConfig' | translate }}
        </span>

        <div class="field span-12" role="group" aria-labelledby="translation-config-title">
          <div class="config-group">
            <div class="toggle-field">
              <div class="p-field-checkbox">
                <p-inputSwitch formControlName="enable" [inputId]="'translation_enable'"
                               [ngClass]="{'field-changed': isFieldDirty('translation_config.enable')}"
                               aria-labelledby="enable-translation-label" [disabled]="isReadonly">
                </p-inputSwitch>
                <label for="translation_enable">{{ 'supervisor.campaignView.translationConfig.enable' | translate }}</label>
              </div>
              <span class="toggle-description">{{ 'supervisor.campaignView.translationConfig.enableDesc' | translate }}</span>
            </div>
          </div>
        </div>

        <!-- Source Language -->
        <div class="field span-6"
             [class.field-invalid]="isFieldInvalid('translation_config.source_language')"
             [class.field-changed]="isFieldDirty('translation_config.source_language')"
             [class.disabled]="!campaignForm.get('translation_config.enable')?.value">
          <label for="source_language" id="source-language-label">{{ 'supervisor.campaignView.translationConfig.sourceLanguage' | translate }}</label>
          <p-dropdown id="source_language" formControlName="source_language"
                      [options]="languageOptions" [placeholder]="'supervisor.campaignView.placeholders.selectSourceLanguage' | translate"
                      aria-labelledby="source-language-label" [autoDisplayFirst]="false"
                      [attr.aria-invalid]="isFieldInvalid('translation_config.source_language')"
                      [attr.aria-describedby]="isFieldInvalid('translation_config.source_language') ? 'source-language-error' : null">
          </p-dropdown>
        </div>

        <!-- Target Language -->
        <div class="field span-6"
             [class.field-invalid]="isFieldInvalid('translation_config.target_language')"
             [class.field-changed]="isFieldDirty('translation_config.target_language')"
             [class.disabled]="!campaignForm.get('translation_config.enable')?.value">
          <label for="target_language" id="target-language-label">{{ 'supervisor.campaignView.translationConfig.targetLanguage' | translate }}</label>
          <p-dropdown id="target_language" formControlName="target_language"
                      [options]="languageOptions" [placeholder]="'supervisor.campaignView.placeholders.selectTargetLanguage' | translate"
                      aria-labelledby="target-language-label" [autoDisplayFirst]="false"
                      [attr.aria-invalid]="isFieldInvalid('translation_config.target_language')"
                      [attr.aria-describedby]="isFieldInvalid('translation_config.target_language') ? 'target-language-error' : null">
          </p-dropdown>
        </div>
      </div>

      <!-- Conversation Configuration Section -->
      <div class="form-section" formGroupName="conversation_config">
        <span class="section-title">
          <i class="pi pi-comments title-icon" aria-hidden="true"></i>
          {{ 'supervisor.campaignView.sections.conversationConfig' | translate }}
        </span>

        <div class="field span-12" role="group" aria-labelledby="conversation-config-title"
             [class.field-changed]="isFieldDirty('conversation_config.allow_automatic_message')">

          <div class="config-group">
            <div class="toggle-field">
              <div class="p-field-checkbox">
                <p-inputSwitch formControlName="allow_automatic_message" [inputId]="'allow_automatic_message'"
                               aria-labelledby="auto-message-label" [disabled]="isReadonly">
                </p-inputSwitch>
                <label for="allow_automatic_message">{{ 'supervisor.campaignView.conversationConfig.enableAutoMessages' | translate }}</label>
              </div>
              <span class="toggle-description">
                {{ 'supervisor.campaignView.conversationConfig.enableAutoMessagesDesc' | translate }}
              </span>
            </div>
          </div>
          <span class="toggle-description">
                {{ 'supervisor.campaignView.conversationConfig.autoMessageFrequencyNote' | translate }}
          </span>
        </div>

        <!-- Message Frequency -->
        <div class="field span-4"
             [class.field-invalid]="isFieldInvalid('conversation_config.how_often_message')"
             [class.field-changed]="isFieldDirty('conversation_config.how_often_message')"
             [class.disabled]="!campaignForm.get('conversation_config.allow_automatic_message')?.value">
          <label for="how_often_message" id="message-frequency-label">
            {{ 'supervisor.campaignView.conversationConfig.messageFrequency' | translate }}
          </label>
          <p-inputNumber id="how_often_message" formControlName="how_often_message"
                         [min]="0" [max]="3600" aria-labelledby="message-frequency-label">
          </p-inputNumber>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('conversation_config.how_often_message')" role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.frequencyGreaterThanZero' | translate }}
          </small>
        </div>

        <!-- Automatic Message Content -->
        <div class="field span-4"
             [class.field-invalid]="isFieldInvalid('conversation_config.automatic_message_value')"
             [class.field-changed]="isFieldDirty('conversation_config.automatic_message_value')"
             [class.disabled]="!campaignForm.get('conversation_config.allow_automatic_message')?.value">
          <label for="automatic_message_value" id="auto-message-content-label">
            {{ 'supervisor.campaignView.conversationConfig.autoMessageContent' | translate }}
          </label>
          <textarea id="automatic_message_value" pInputTextarea
                    formControlName="automatic_message_value" rows="1" maxlength="500"
                    aria-labelledby="auto-message-content-label" [placeholder]="'supervisor.campaignView.placeholders.writeAutoMessage' | translate">
          </textarea>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('conversation_config.automatic_message_value')"
                 role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.messageRequired' | translate }}
          </small>
        </div>

        <!-- Retries -->
        <div class="field span-4"
             [class.field-changed]="isFieldDirty('conversation_config.retries')"
             [class.disabled]="!campaignForm.get('conversation_config.allow_automatic_message')?.value">
          <label for="retries" id="retries-label">{{ 'supervisor.campaignView.conversationConfig.retries' | translate }}</label>
          <p-inputNumber id="retries" formControlName="retries"
                         [min]="0" [max]="10" aria-labelledby="retries-label">
          </p-inputNumber>
          <small class="validation-message">
            {{ 'supervisor.campaignView.conversationConfig.retriesDesc' | translate }}
          </small>
        </div>


        <!-- Automatic Notifications Queue Display & Edit -->
        <div class="field span-12"
             [class.disabled]="!campaignForm.get('conversation_config.allow_automatic_message')?.value">
          <label>{{ 'supervisor.campaignView.notifications.queueTitle' | translate }}</label> <!-- todo: adicionar estilos a este titulo en una clase hija de field -->

          <div class="notifications-list">
            <div class="list-container" *ngIf="automaticNotificationsQueue.length > 0; else noNotifications">

              <div class="list-header">
                <span class="list-count">
                  <i class="pi pi-list" aria-hidden="true"></i> {{ automaticNotificationsQueue.length }} {{ 'supervisor.campaignView.notifications.configuredCount' | translate }}
                </span>
                <button pButton type="button" [label]="'supervisor.campaignView.buttons.clearAll' | translate" icon="pi pi-trash"
                        (click)="clearAllNotifications()"
                        [disabled]="editingNotificationIndex >= 0 || isReadonly"
                        [style.display]="canEdit ? 'inline-block' : 'none'" [title]="'supervisor.campaignView.notifications.clearAllTitle' | translate">
                </button>
              </div>

              <div class="list-item" [class.editing]="editingNotificationIndex === i"
                   *ngFor="let notification of automaticNotificationsQueue.controls; let i = index">
                <div class="item-header">
                  <span class="item-index">
                    {{ 'supervisor.campaignView.notifications.notification' | translate }} {{ i + 1 }} ({{ 'supervisor.campaignView.header.id' | translate }}: {{ notification.get('id_retrie')?.value }})
                  </span>
                  <div class="item-actions">
                    <button pButton type="button" icon="pi pi-pencil"
                            class="p-button-text p-button-sm p-button-rounded" (click)="editNotification(i)"
                            [disabled]="editingNotificationIndex >= 0 || isReadonly"
                            [style.display]="canEdit ? 'inline-block' : 'none'"
                            [attr.aria-label]="('supervisor.campaignView.aria.editNotification' | translate) + ' ' + (i + 1)" [title]="'supervisor.campaignView.notifications.editTitle' | translate">
                    </button>
                    <button pButton type="button" icon="pi pi-trash"
                            class="p-button-text p-button-sm p-button-rounded p-button-danger"
                            (click)="removeNotificationFromQueue(i)"
                            [disabled]="editingNotificationIndex >= 0 || isReadonly"
                            [style.display]="canEdit ? 'inline-block' : 'none'"
                            [attr.aria-label]="('supervisor.campaignView.aria.removeNotification' | translate) + ' ' + (i + 1)" [title]="'supervisor.campaignView.notifications.removeTitle' | translate">
                    </button>
                  </div>
                </div>

                <div class="item-content">
                  <ng-container *ngIf="editingNotificationIndex === i; else staticNotification">
                    <div class="field">
                      <label>{{ 'supervisor.campaignView.notifications.retryId' | translate }}</label>
                      <input pInputText [value]="i + 1" readonly/>
                    </div>
                    <div class="field">
                      <label>{{ 'supervisor.campaignView.notifications.message' | translate }}</label>
                      <textarea pInputTextarea
                                [(ngModel)]="notificationEditBuffer[i].message"
                                [ngModelOptions]="{standalone: true}"
                                rows="2"
                                maxlength="500"
                                autocomplete="off"
                                [placeholder]="'supervisor.campaignView.placeholders.editMessage' | translate">
                              </textarea>
                      <small class="text-muted">
                        {{ notificationEditBuffer[i].message.length || 0 }}/500 {{ 'supervisor.campaignView.characters' | translate }}
                      </small>
                    </div>
                    <div class="field">
                      <label>{{ 'supervisor.campaignView.notifications.waitTime' | translate }}</label>
                      <input type="number"
                             pInputText
                             [(ngModel)]="notificationEditBuffer[i].time"
                             [ngModelOptions]="{standalone: true}"
                             min="0"
                             [placeholder]="'supervisor.campaignView.placeholders.timeSeconds' | translate"/>
                    </div>
                    <div class="item-actions item-actions--editing">
                      <button pButton type="button" [label]="'supervisor.campaignView.buttons.save' | translate" icon="pi pi-check" (click)="updateNotification()"
                              class="p-button-success"
                              [disabled]="!notificationEditBuffer[i].message.trim() || notificationEditBuffer[i].time == null">
                      </button>
                      <button pButton type="button" [label]="'supervisor.campaignView.buttons.cancel' | translate" icon="pi pi-times"
                              class="p-button-secondary"
                              (click)="cancelEditNotification()">
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #staticNotification>
                    <div class="message-text">
                      <strong>{{ 'supervisor.campaignView.notifications.message' | translate }}:</strong> {{ notification.get('message')?.value }}<br>
                      <strong>{{ 'supervisor.campaignView.notifications.waitTimeShort' | translate }}:</strong> {{ notification.get('time')?.value }} {{ 'supervisor.campaignView.seconds' | translate }}
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>


            <ng-template #noNotifications>
              <div class="empty-state">
                <i class="pi pi-info-circle" aria-hidden="true"></i>
                <span>{{ 'supervisor.campaignView.empty.noNotifications' | translate }}</span>
                <small *ngIf="canShowInputs">
                  {{ 'supervisor.campaignView.empty.noNotificationsHint' | translate }}
                </small>
              </div>
            </ng-template>


            <!-- Add New Notification Form  class="p-inputgroup notifications-inputgroup" -->
            <p-inputgroup class="notifications-inputgroup" *ngIf="canShowInputs && editingNotificationIndex === -1">
              <!--              <span class="p-inputgroup-addon">-->
              <!--                <i class="pi pi-bell" aria-hidden="true"></i>-->
              <!--              </span>-->
              <input pInputText
                     [value]="automaticNotificationsQueue.length + 1"
                     readonly
                     tabindex="-1"
                     [attr.aria-label]="'supervisor.campaignView.notifications.retryId' | translate"/>
              <textarea pInputTextarea
                        [(ngModel)]="newNotificationMessage"
                        [ngModelOptions]="{standalone: true}"
                        [placeholder]="'supervisor.campaignView.placeholders.notificationMessage' | translate"
                        rows="2"
                        maxlength="500"
                        autocomplete="off">
                      </textarea>
              <input type="number"
                     pInputText
                     [(ngModel)]="newNotificationTime"
                     [ngModelOptions]="{standalone: true}"
                     min="0"
                     [placeholder]="'supervisor.campaignView.placeholders.timeSeconds' | translate"/>
              <button pButton
                      type="button"
                      icon="pi pi-plus"
                      class="p-button-success"
                      (click)="addNotificationToQueue()"
                      [disabled]="!newNotificationMessage.trim() || newNotificationTime == null"
                      [attr.aria-label]="'supervisor.campaignView.aria.addNotification' | translate"
                      [title]="'supervisor.campaignView.notifications.addTitle' | translate">
              </button>
            </p-inputgroup>
            <small [class]="'text-muted ' + getCharacterCountClass(newNotificationMessage, 500)"
                   *ngIf="newNotificationMessage && canShowInputs && editingNotificationIndex === -1"
                   class="character-count">
              {{ newNotificationMessage.length }}/500 {{ 'supervisor.campaignView.characters' | translate }}
            </small>
          </div>
        </div>
      </div>


      <!-- Time Settings Configuration Section -->
      <div class="form-section" formGroupName="time_settings_config" *ngIf="false">
        <span class="section-title" id="time-settings-title">
          <i class="pi pi-clock title-icon" aria-hidden="true"></i>
          <span>{{ 'supervisor.campaignView.sections.timeSettings' | translate }}</span>
        </span>

        <!-- Enable Time Settings Toggle -->
        <div class="field toggle-field span-12"
             [class.field-changed]="isFieldDirty('time_settings_config.enable')">
          <label for="time_settings_enable" id="time-settings-enable-label">
            {{ 'supervisor.campaignView.timeSettings.enable' | translate }}
          </label>
          <p-inputSwitch id="time_settings_enable"
                         formControlName="enable"
                         aria-labelledby="time-settings-enable-label"
                         [disabled]="isReadonly">
          </p-inputSwitch>
        </div>

        <!-- Days Selection -->
        <div class="field span12"
             [class.field-invalid]="isFieldInvalid('time_settings_config.days')"
             [class.field-changed]="isFieldDirty('time_settings_config.days')"
             [class.disabled]="!campaignForm.get('time_settings_config.enable')?.value">
          <label for="time_settings_days" id="time-settings-days-label">
            {{ 'supervisor.campaignView.timeSettings.operationDays' | translate }}
          </label>
          <p-multiSelect id="time_settings_days"
                         formControlName="days"
                         [options]="dayOptions"
                         [placeholder]="'supervisor.campaignView.placeholders.selectDays' | translate"

                         aria-labelledby="time-settings-days-label">
          </p-multiSelect>
          <small class="validation-message"
                 *ngIf="isFieldInvalid('time_settings_config.days')"
                 role="alert">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            {{ 'supervisor.campaignView.validation.atLeastOneDay' | translate }}
          </small>
        </div>

        <div
          class="field span-12"
        >
          <!-- Start Time Configuration -->
          <div class="config-group"
               [class.disabled]="!campaignForm.get('time_settings_config.enable')?.value">
            <div class="config-group-title">
              <i class="pi pi-play" aria-hidden="true"></i>
              <span>{{ 'supervisor.campaignView.timeSettings.startTime' | translate }}</span>
            </div>

            <div formGroupName="start_time" class="time-group">
              <div class="field time-field">
                <label for="start_hours">{{ 'supervisor.campaignView.timeSettings.hours' | translate }}</label>
                <p-dropdown id="start_hours"
                            formControlName="hours"
                            [options]="hourOptions"
                >
                </p-dropdown>
              </div>
              <div class="field time-field">
                <label for="start_minutes">{{ 'supervisor.campaignView.timeSettings.minutes' | translate }}</label>
                <p-dropdown id="start_minutes"
                            formControlName="minutes"
                            [options]="minuteSecondOptions"
                >
                </p-dropdown>
              </div>
              <div class="field time-field">
                <label for="start_seconds">{{ 'supervisor.campaignView.timeSettings.seconds' | translate }}</label>
                <p-dropdown id="start_seconds"
                            formControlName="seconds"
                            [options]="minuteSecondOptions"
                >
                </p-dropdown>
              </div>
            </div>
          </div>

          <!-- End Time Configuration -->
          <div class="config-group"
               [class.disabled]="!campaignForm.get('time_settings_config.enable')?.value">
            <div class="config-group-title">
              <i class="pi pi-stop" aria-hidden="true"></i>
              <span>{{ 'supervisor.campaignView.timeSettings.endTime' | translate }}</span>
            </div>

            <div formGroupName="end_time" class="time-group">
              <div class="field time-field">
                <label for="end_hours">{{ 'supervisor.campaignView.timeSettings.hours' | translate }}</label>
                <p-dropdown id="end_hours"
                            formControlName="hours"
                            [options]="hourOptions"
                >
                </p-dropdown>
              </div>
              <div class="field time-field">
                <label for="end_minutes">{{ 'supervisor.campaignView.timeSettings.minutes' | translate }}</label>
                <p-dropdown id="end_minutes"
                            formControlName="minutes"
                            [options]="minuteSecondOptions"
                >
                </p-dropdown>
              </div>
              <div class="field time-field">
                <label for="end_seconds">{{ 'supervisor.campaignView.timeSettings.seconds' | translate }}</label>
                <p-dropdown id="end_seconds"
                            formControlName="seconds"
                            [options]="minuteSecondOptions"
                >
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Agent Configuration Section -->
      <div class="form-section" formGroupName="agent_config">
        <span class="section-title">
          <i class="pi pi-users title-icon" aria-hidden="true"></i>
          {{ 'supervisor.campaignView.sections.agentConfig' | translate }}
        </span>

        <div class="field toggle-field span-6"
             [class.field-changed]="isFieldDirty('agent_config.enable')">
          <div class="p-field-checkbox">
            <p-inputSwitch id="agent_config_enable"
                           formControlName="enable"
                           [inputId]="'agent_config_enable'"
                           aria-labelledby="agent-config-enable-label"
                           [disabled]="isReadonly">
            </p-inputSwitch>
            <label for="agent_config_enable" id="agent-config-enable-label">
              {{ 'supervisor.campaignView.agentConfig.enable' | translate }}
            </label>
          </div>
        </div>

        <div class="field toggle-field span-6"
             [class.field-changed]="isFieldDirty('agent_config.transfer_between_agent')"
             [class.disabled]="!campaignForm.get('agent_config.enable')?.value">
          <div class="p-field-checkbox">
            <p-inputSwitch id="transfer_between_agent"
                           formControlName="transfer_between_agent"
                           [inputId]="'transfer_between_agent'"
                           aria-labelledby="transfer-agent-label"
                           [disabled]="isReadonly">
            </p-inputSwitch>
            <label for="transfer_between_agent" id="transfer-agent-label">
              {{ 'supervisor.campaignView.agentConfig.transferBetweenAgents' | translate }}
            </label>
          </div>
        </div>

        <div class="field toggle-field span-12"
             [class.field-changed]="isFieldDirty('agent_config.enable_priority_agent')"
             [class.disabled]="!campaignForm.get('agent_config.enable')?.value">
          <div class="p-field-checkbox">
            <p-inputSwitch id="enable_priority_agent"
                           formControlName="enable_priority_agent"
                           [inputId]="'enable_priority_agent'"
                           aria-labelledby="priority-agent-label"
                           [disabled]="isReadonly">
            </p-inputSwitch>
            <label for="enable_priority_agent" id="priority-agent-label">
              {{ 'supervisor.campaignView.agentConfig.enablePriority' | translate }}
            </label>
          </div>
          <small class="field-help">
            {{ 'supervisor.campaignView.agentConfig.enablePriorityHelp' | translate }}
          </small>
        </div>

        <!-- Orden de prioridad (solo lectura / vacío) -->
        <div class="field span-6"
             *ngIf="campaignForm.get('agent_config.enable_priority_agent')?.value && previousOrderPriorityAgent.length > 0"
             [class.disabled]="!campaignForm.get('agent_config.enable')?.value">
          <div class="config-group">
            <div class="config-group-title">
              <i class="pi pi-sort-amount-down" aria-hidden="true"></i>
              <span>{{ 'supervisor.campaignView.agentConfig.priorityOrderReadonly' | translate }}</span>
            </div>

            <div class="agent-priority-list">
              <div class="agent-priority-note">
                <i class="pi pi-info-circle" aria-hidden="true"></i>
                <span>{{ 'supervisor.campaignView.agentConfig.priorityOrderNote' | translate }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="field span-6"
             *ngIf="campaignForm.get('agent_config.enable_priority_agent')?.value && previousOrderPriorityAgent.length === 0"
             [class.disabled]="!campaignForm.get('agent_config.enable')?.value"
        >
          <div class="config-group">
            <div class="config-group-title">
              <i class="pi pi-sort-amount-down" aria-hidden="true"></i>
              <span>{{ 'supervisor.campaignView.agentConfig.priorityOrder' | translate }}</span>
            </div>

            <div class="empty-priority-state">
              <i class="pi pi-users" aria-hidden="true"></i>
              <p>{{ 'supervisor.campaignView.agentConfig.noPriorityAgents' | translate }}</p>
              <small>{{ 'supervisor.campaignView.agentConfig.noPriorityAgentsHint' | translate }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Default Messages Configuration Section -->
      <div class="form-section" formGroupName="default_messages_config">
        <span class="section-title" id="default-messages-title">
          <i class="pi pi-envelope title-icon" aria-hidden="true"></i>
          {{ 'supervisor.campaignView.sections.defaultMessages' | translate }}
        </span>

        <div class="field toggle-field span-12"
             [class.field-changed]="isFieldDirty('default_messages_config.enable')">
          <div class="p-field-checkbox">
            <p-inputSwitch id="default_messages_enable"
                           formControlName="enable"
                           [inputId]="'default_messages_enable'"
                           aria-labelledby="default-messages-enable-label"
                           [disabled]="isReadonly">
            </p-inputSwitch>
            <label for="default_messages_enable" id="default-messages-enable-label">
              {{ 'supervisor.campaignView.defaultMessages.enable' | translate }}
            </label>
          </div>
          <span class="toggle-description">
                {{ 'supervisor.campaignView.defaultMessages.enableDesc' | translate }}
              </span>
        </div>

        <!-- Gestión de mensajes -->
        <div class="field span-12" [class.disabled]="!campaignForm.get('default_messages_config.enable')?.value">
          <label for="new_message" id="new-message-label">{{ 'supervisor.campaignView.defaultMessages.manage' | translate }}</label>

          <div class="p-inputgroup"
               *ngIf="campaignForm.get('default_messages_config.enable')?.value && canShowInputs">
                    <span class="p-inputgroup-addon">
                      <i class="pi pi-envelope" aria-hidden="true"></i>
                    </span>
            <textarea id="new_message"
                      pInputTextarea
                      [(ngModel)]="newMessage"
                      [ngModelOptions]="{standalone: true}"
                      [placeholder]="'supervisor.campaignView.placeholders.writeNewMessage' | translate"
                      aria-labelledby="new-message-label"
                      rows="3"
                      maxlength="500"
                      autocomplete="off">
                    </textarea>
            <button pButton
                    type="button"
                    *ngIf="editingMessageIndex === -1"
                    icon="pi pi-plus"
                    class="p-button-success"
                    (click)="addDefaultMessage()"
                    [disabled]="!newMessage.trim()"
                    [attr.aria-label]="'supervisor.campaignView.aria.addMessage' | translate"
                    [title]="'supervisor.campaignView.defaultMessages.addTitle' | translate">
            </button>
            <button pButton
                    type="button"
                    *ngIf="editingMessageIndex >= 0"
                    icon="pi pi-check"
                    class="p-button-success"
                    (click)="updateDefaultMessage()"
                    [disabled]="!newMessage.trim()"
                    [attr.aria-label]="'supervisor.campaignView.aria.updateMessage' | translate"
                    [title]="'supervisor.campaignView.defaultMessages.updateTitle' | translate">
            </button>
            <button pButton
                    type="button"
                    *ngIf="editingMessageIndex >= 0"
                    icon="pi pi-times"
                    class="p-button-secondary"
                    (click)="cancelEditMessage()"
                    [attr.aria-label]="'supervisor.campaignView.aria.cancelEdit' | translate"
                    [title]="'supervisor.campaignView.buttons.cancelEdit' | translate">
            </button>
          </div>

          <span [class]="'text-muted mb-2 ' + getCharacterCountClass(newMessage, 500)"
                *ngIf="newMessage && campaignForm.get('default_messages_config.enable')?.value && canShowInputs">
              {{ newMessage.length }}/500 {{ 'supervisor.campaignView.characters' | translate }}
            </span>

          <div class="messages-list">
            <div class="message-items"
                 *ngIf="campaignForm.get('default_messages_config.messages')?.value?.length > 0; else noMessages">
              <div class="messages-header justify-content-between align-items-center">
                        <span class="messages-count text-white-alpha-90">
                          <i class="pi pi-list" aria-hidden="true"></i>
                          {{ campaignForm.get('default_messages_config.messages')?.value?.length }} {{ 'supervisor.campaignView.defaultMessages.configuredCount' | translate }}
                        </span>
                <button pButton
                        type="button"
                        [label]="'supervisor.campaignView.buttons.clearAll' | translate"
                        icon="pi pi-trash"
                        class="p-button-sm p-button-outlined p-button-danger"
                        (click)="clearAllDefaultMessages()"
                        [disabled]="editingMessageIndex >= 0 || isReadonly"
                        [style.display]="canEdit ? 'inline-block' : 'none'"
                        [title]="'supervisor.campaignView.defaultMessages.clearAllTitle' | translate">
                </button>
              </div>
              <div class="message-item p-3 border-1 surface-border border-round"
                   *ngFor="let message of campaignForm.get('default_messages_config.messages')?.value; let i = index"
                   [class.editing]="editingMessageIndex === i">
                <div class="message-header mb-2 justify-content-between align-items-center">
                  <span class="message-index font-semibold text-white-alpha-90">{{ 'supervisor.campaignView.defaultMessages.message' | translate }} {{ i + 1 }}</span>
                  <div class="message-actions">
                    <span class="message-length text-sm text-600 mr-2">{{ message.length }} {{ 'supervisor.campaignView.characters' | translate }}</span>
                    <button pButton
                            type="button"
                            icon="pi pi-pencil"
                            class="p-button-text p-button-sm p-button-rounded"
                            (click)="editDefaultMessage(i)"
                            [disabled]="editingMessageIndex >= 0 || isReadonly"
                            [style.display]="canEdit ? 'inline-block' : 'none'"
                            [attr.aria-label]="('supervisor.campaignView.aria.editMessage' | translate) + ' ' + (i + 1)"
                            [title]="'supervisor.campaignView.defaultMessages.editTitle' | translate">
                    </button>
                    <button pButton
                            type="button"
                            icon="pi pi-trash"
                            class="p-button-text p-button-sm p-button-rounded p-button-danger"
                            (click)="removeDefaultMessage(i)"
                            [disabled]="editingMessageIndex >= 0 || isReadonly"
                            [style.display]="canEdit ? 'inline-block' : 'none'"
                            [attr.aria-label]="('supervisor.campaignView.aria.removeMessage' | translate) + ' ' + (i + 1)"
                            [title]="'supervisor.campaignView.defaultMessages.removeTitle' | translate">
                    </button>
                  </div>
                </div>
                <div class="message-content-display">
                  <ng-container *ngIf="editingMessageIndex === i; else staticMessage">
                            <textarea pInputTextarea
                                      [(ngModel)]="messageEditBuffer[i]"
                                      [ngModelOptions]="{standalone: true}"
                                      rows="3"
                                      maxlength="500"
                                      autocomplete="off"
                                      [placeholder]="'supervisor.campaignView.placeholders.editMessage' | translate">
                            </textarea>
                    <small class="text-muted">{{ messageEditBuffer[i].length || 0 }}/500 {{ 'supervisor.campaignView.characters' | translate }}</small>
                    <div class="message-actions gap-2 mt-2">
                      <button pButton
                              type="button"
                              [label]="'supervisor.campaignView.buttons.save' | translate"
                              icon="pi pi-check"
                              class="p-button-success"
                              (click)="updateDefaultMessage()"
                              [disabled]="!messageEditBuffer[i] || !messageEditBuffer[i].trim()">
                      </button>
                      <button pButton
                              type="button"
                              [label]="'supervisor.campaignView.buttons.cancel' | translate"
                              icon="pi pi-times"
                              class="p-button-secondary"
                              (click)="cancelEditMessage()">
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #staticMessage>
                    <div class="message-text text-color">
                      {{ message }}
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
            <ng-template #noMessages>
              <div class="text-muted p-3 text-center border-1 surface-border border-round">
                <i class="pi pi-info-circle mr-2" aria-hidden="true"></i>
                {{ 'supervisor.campaignView.empty.noMessages' | translate }}
                <div class="mt-2 text-sm" *ngIf="campaignForm.get('default_messages_config.enable')?.value">
                  {{ 'supervisor.campaignView.empty.noMessagesHint' | translate }}
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Default Questions & Answers Configuration Section -->
      <div class="form-section" formGroupName="default_questions_answers_config">
        <span class="section-title" id="default-qa-title">
          <i class="pi pi-question-circle title-icon" aria-hidden="true"></i>
          {{ 'supervisor.campaignView.sections.defaultQA' | translate }}
        </span>

        <div class="field toggle-field span-12"
             [class.field-changed]="isFieldDirty('default_questions_answers_config.enable')">
          <div class="p-field-checkbox">
            <p-inputSwitch id="default_qa_enable"
                           formControlName="enable"
                           [inputId]="'default_qa_enable'"
                           aria-labelledby="default-qa-enable-label"
                           [disabled]="isReadonly">
            </p-inputSwitch>
            <label for="default_qa_enable" id="default-qa-enable-label">
              {{ 'supervisor.campaignView.defaultQA.enable' | translate }}
            </label>
          </div>
          <span class="toggle-description">
                {{ 'supervisor.campaignView.defaultQA.enableDesc' | translate }}
              </span>
        </div>

        <!-- Questions & Answers Management -->
        <div class="field span-12"
             [class.disabled]="!campaignForm.get('default_questions_answers_config.enable')?.value">
          <label for="new_question" id="new-qa-label">{{ 'supervisor.campaignView.defaultQA.manage' | translate }}</label>

          <div class="qa-input-form"
               *ngIf="campaignForm.get('default_questions_answers_config.enable')?.value && (!campaignId || canEdit)">

            <!-- Question -->
            <div class="field">
              <label for="new_question" class="font-semibold">
                <i class="pi pi-question-circle mr-1" aria-hidden="true"></i>
                {{ 'supervisor.campaignView.defaultQA.question' | translate }}
              </label>
              <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          <i class="pi pi-question" aria-hidden="true"></i>
                        </span>
                <textarea id="new_question"
                          pInputTextarea
                          [(ngModel)]="newQuestion"
                          [ngModelOptions]="{standalone: true}"
                          [placeholder]="'supervisor.campaignView.placeholders.writeQuestion' | translate"
                          aria-labelledby="new-qa-label"
                          rows="2"
                          maxlength="300"
                          autocomplete="off">
                        </textarea>
              </div>
              <small [class]="'text-muted ' + getCharacterCountClass(newQuestion, 300)" *ngIf="newQuestion">
                {{ newQuestion.length }}/300 {{ 'supervisor.campaignView.characters' | translate }}
              </small>
            </div>

            <!-- Answer -->
            <div class="field">
              <label for="new_answer" class="font-semibold">
                <i class="pi pi-check-circle mr-1" aria-hidden="true"></i>
                {{ 'supervisor.campaignView.defaultQA.answer' | translate }}
              </label>
              <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          <i class="pi pi-comment" aria-hidden="true"></i>
                        </span>
                <textarea id="new_answer"
                          pInputTextarea
                          [(ngModel)]="newAnswer"
                          [ngModelOptions]="{standalone: true}"
                          [placeholder]="'supervisor.campaignView.placeholders.writeAnswer' | translate"
                          rows="3"
                          maxlength="500"
                          autocomplete="off">
                        </textarea>
              </div>
              <small [class]="'text-muted ' + getCharacterCountClass(newAnswer, 500)" *ngIf="newAnswer">
                {{ newAnswer.length }}/500 {{ 'supervisor.campaignView.characters' | translate }}
              </small>
            </div>

            <!-- Actions -->
            <div class="qa-actions gap-2">
              <button pButton
                      type="button"
                      *ngIf="editingQAIndex === -1"
                      [label]="'supervisor.campaignView.buttons.addQAPair' | translate"
                      icon="pi pi-plus"
                      class="p-button-success"
                      (click)="addDefaultQuestionAnswer()"
                      [disabled]="!newQuestion.trim() || !newAnswer.trim()">
              </button>
              <button pButton
                      type="button"
                      *ngIf="editingQAIndex >= 0"
                      [label]="'supervisor.campaignView.buttons.updateQAPair' | translate"
                      icon="pi pi-check"
                      class="p-button-success"
                      (click)="updateDefaultQuestionAnswer()"
                      [disabled]="!newQuestion.trim() || !newAnswer.trim()">
              </button>
              <button pButton
                      type="button"
                      *ngIf="editingQAIndex >= 0"
                      [label]="'supervisor.campaignView.buttons.cancelEdit' | translate"
                      icon="pi pi-times"
                      class="p-button-secondary"
                      (click)="cancelEditQuestionAnswer()">
              </button>
            </div>
          </div>

          <!-- Q&A List -->
          <div class="qa-list">
            <div class="qa-items"
                 *ngIf="campaignForm.get('default_questions_answers_config.questions_answers')?.value?.length > 0; else noQA">
              <div class="qa-header justify-content-between align-items-center">
                        <span class="qa-count text-white-alpha-90">
                          <i class="pi pi-list mr-1" aria-hidden="true"></i>
                          {{ campaignForm.get('default_questions_answers_config.questions_answers')?.value?.length }}
                          {{ 'supervisor.campaignView.defaultQA.configuredCount' | translate }}
                        </span>
                <button pButton
                        type="button"
                        [label]="'supervisor.campaignView.buttons.clearAll' | translate"
                        icon="pi pi-trash"
                        class="p-button-sm p-button-outlined p-button-danger"
                        (click)="clearAllDefaultQuestionAnswers()"
                        [disabled]="editingQAIndex >= 0 || isReadonly"
                        [style.display]="canEdit ? 'inline-block' : 'none'"
                        [title]="'supervisor.campaignView.defaultQA.clearAllTitle' | translate">
                </button>
              </div>
              <div class="qa-item mb-4 p-3 border-1 surface-border border-round"
                   *ngFor="let qa of campaignForm.get('default_questions_answers_config.questions_answers')?.value; let i = index"
                   [class.editing]="editingQAIndex === i">
                <div class="qa-item-header">
                  <span class="qa-index font-semibold text-white-alpha-90">{{ 'supervisor.campaignView.defaultQA.qaPair' | translate }} {{ i + 1 }}</span>
                  <div class="qa-stats">
                    <span class="question-length text-sm text-600">{{ 'supervisor.campaignView.defaultQA.questionAbbr' | translate }}: {{ qa.question?.length || 0 }} {{ 'supervisor.campaignView.charsAbbr' | translate }}</span>
                    <span class="answer-length text-sm text-600 ml-2">{{ 'supervisor.campaignView.defaultQA.answerAbbr' | translate }}: {{ qa.answer?.length || 0 }} {{ 'supervisor.campaignView.charsAbbr' | translate }}</span>
                  </div>
                  <div class="qa-actions">
                    <button pButton
                            type="button"
                            icon="pi pi-pencil"
                            class="p-button-text p-button-sm p-button-rounded mr-1"
                            (click)="editDefaultQuestionAnswer(i)"
                            [disabled]="editingQAIndex >= 0 || isReadonly"
                            [style.display]="canEdit ? 'inline-block' : 'none'"
                            [attr.aria-label]="('supervisor.campaignView.aria.editQA' | translate) + ' ' + (i + 1)"
                            [title]="'supervisor.campaignView.defaultQA.editTitle' | translate">
                    </button>
                    <button pButton
                            type="button"
                            icon="pi pi-trash"
                            class="p-button-text p-button-sm p-button-rounded p-button-danger"
                            (click)="removeDefaultQuestionAnswer(i)"
                            [disabled]="editingQAIndex >= 0 || isReadonly"
                            [style.display]="canEdit ? 'inline-block' : 'none'"
                            [attr.aria-label]="('supervisor.campaignView.aria.removeQA' | translate) + ' ' + (i + 1)"
                            [title]="'supervisor.campaignView.defaultQA.removeTitle' | translate">
                    </button>
                  </div>
                </div>
                <div class="qa-content">
                  <ng-container *ngIf="editingQAIndex === i; else staticQA">
                    <div class="qa-question-section">
                      <div class="qa-label mb-2">
                        <i class="pi pi-question-circle text-primary mr-1" aria-hidden="true"></i>
                        <strong class="text-primary">{{ 'supervisor.campaignView.defaultQA.question' | translate }} {{ i + 1 }}:</strong>
                      </div>
                      <textarea pInputTextarea
                                [(ngModel)]="qaEditBuffer[i].question"
                                [ngModelOptions]="{standalone: true}"
                                rows="2"
                                maxlength="300"
                                autocomplete="off"
                                [placeholder]="'supervisor.campaignView.placeholders.editQuestion' | translate">
                              </textarea>
                      <small class="text-muted">{{ qaEditBuffer[i] && qaEditBuffer[i].question.length || 0 }}/300
                        {{ 'supervisor.campaignView.characters' | translate }}</small>
                    </div>
                    <div class="qa-answer-section">
                      <div class="qa-label mb-2">
                        <i class="pi pi-check-circle text-success mr-1" aria-hidden="true"></i>
                        <strong class="text-success">{{ 'supervisor.campaignView.defaultQA.answer' | translate }}:</strong>
                      </div>
                      <textarea pInputTextarea
                                [(ngModel)]="qaEditBuffer[i].answer"
                                [ngModelOptions]="{standalone: true}"
                                rows="3"
                                maxlength="500"
                                autocomplete="off"
                                [placeholder]="'supervisor.campaignView.placeholders.editAnswer' | translate">
                              </textarea>
                      <small class="text-muted">{{ qaEditBuffer[i] && qaEditBuffer[i].answer.length || 0 }}/500
                        {{ 'supervisor.campaignView.characters' | translate }}</small>
                    </div>
                    <div class="qa-actions gap-2">
                      <button pButton
                              type="button"
                              [label]="'supervisor.campaignView.buttons.save' | translate"
                              icon="pi pi-check"
                              class="p-button-success"
                              (click)="updateDefaultQuestionAnswer()"
                              [disabled]="!(qaEditBuffer[i] && qaEditBuffer[i].question && qaEditBuffer[i].question.trim() && qaEditBuffer[i].answer && qaEditBuffer[i].answer.trim())">
                      </button>
                      <button pButton
                              type="button"
                              [label]="'supervisor.campaignView.buttons.cancel' | translate"
                              icon="pi pi-times"
                              class="p-button-secondary"
                              (click)="cancelEditQuestionAnswer()">
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #staticQA>
                    <div class="qa-question-section">
                      <div class="qa-label mb-2">
                        <i class="pi pi-question-circle text-primary mr-1" aria-hidden="true"></i>
                        <strong class="text-primary">{{ 'supervisor.campaignView.defaultQA.question' | translate }} {{ i + 1 }}:</strong>
                      </div>
                      <div class="qa-question-text p-2 bg-primary-50 border-round text-color">
                        {{ qa.question }}
                      </div>
                    </div>
                    <div class="qa-answer-section">
                      <div class="qa-label mb-2">
                        <i class="pi pi-check-circle text-success mr-1" aria-hidden="true"></i>
                        <strong class="text-success">{{ 'supervisor.campaignView.defaultQA.answer' | translate }}:</strong>
                      </div>
                      <div class="qa-answer-text p-2 bg-white border-round text-color">
                        {{ qa.answer }}
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
            <ng-template #noQA>
              <div class="text-muted p-3 text-center border-1 surface-border border-round">
                <i class="pi pi-info-circle mr-2" aria-hidden="true"></i>
                {{ 'supervisor.campaignView.empty.noQA' | translate }}
                <div class="mt-2 text-sm"
                     *ngIf="campaignForm.get('default_questions_answers_config.enable')?.value">
                  {{ 'supervisor.campaignView.empty.noQAHint' | translate }}
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </form>

    <!-- Form Actions -->
    <div class="form-actions">
      <button (click)="goBack()"
              pButton
              type="button"
              [label]="'supervisor.campaignView.buttons.cancel' | translate"
              icon="pi pi-times"
              class="p-button-secondary">
      </button>

      <button *ngIf="isEditing"
              (click)="updateCampaign()"
              pButton
              type="button"
              [label]="'supervisor.campaignView.buttons.update' | translate"
              icon="pi pi-save"
              class="p-button-success"
              [disabled]="campaignForm.invalid || !campaignForm.dirty || isLoading"
              [class.p-button-loading]="isSubmitting"
              aria-live="assertive">
      </button>

      <button *ngIf="!campaignId"
              (click)="createCampaign()"
              pButton
              type="button"
              [label]="'supervisor.campaignView.buttons.create' | translate"
              icon="pi pi-plus-circle"
              class="p-button-success"
              [disabled]="campaignForm.invalid || isLoading"
              [class.p-button-loading]="isSubmitting"
              aria-live="assertive">
      </button>
    </div>
  </div>
</div>

<!-- Notification Toast -->
<p-toast position="top-right" key="campaign-actions" aria-live="assertive"></p-toast>
